/**
 * Angular imports.
 */
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

/**
 * Constant imports.
 */
import { CONTENT_VISIBILITY, HCF_TEMPLATES, HCF_TEMPLATE_STATUS, NUMBERS } from '../../../../app/constants/app.constants';

/**
 * Modal imports.
*/
import { TemplatesInfo } from '../template.interface';
import { Target } from '../../../onboarding/interface/global.model';

/**
 * This component is used to display the templates of the hcf.
 */
@Component({
  selector: 'app-hcf-template',
  templateUrl: './hcf-template.component.html',
  styleUrls: ['./hcf-template.component.scss']
})
export class HcfTemplateComponent implements OnInit {

  /**
   * Defined the theme of the template.
   * Store the template basic information.
   */
  @Input() template: number;
  @Input() templateInfo: TemplatesInfo;
  @Input() productCount: number;
  @Input() playTime;
  @Input() callingfrom;

  /**
   * flag that parent component is continue watch view all screen
   */
  @Input() viewAll;

  @Input() buttonLabel: string;

  /**
   * Emit the template button target.
   */
  @Output() emitCardTarget: EventEmitter<Target> = new EventEmitter();

  /**
   * Emit the template card button cta.
   */
  @Output() emitCtaTarget: EventEmitter<Target> = new EventEmitter();
  /**
   * Templates for the hcf.
   * Template status for show/hide.
   */
  public templateConstant = HCF_TEMPLATES;
  public templateStatus = HCF_TEMPLATE_STATUS;
  public contentVisibility = CONTENT_VISIBILITY;

  /**
   * constant for numbers
   */
  public number = NUMBERS;
  /**
   * variables to show video progress
   */
  public width: string;
  /**
   * Emit the template button target.
   */
  cardTarget(cardTarget: Target): void {
    this.emitCardTarget.emit(cardTarget);
  }

  /**
   * Emit the template card button cta.
   */
  ctaTarget(target: Target): void {
    this.emitCtaTarget.emit(target);
  }
  ngOnInit(): void {
    /**
     * calculating width of progress bar in case of continue watch
     */
    if (this.template === this.templateConstant.FOUR) {
      this.width = ((this.templateInfo?.time?.total >= this.templateInfo?.time?.watch) && (this.templateInfo?.time?.total != 0)) ? Math.round((this.templateInfo?.time?.watch * 100) / this.templateInfo?.time?.total) + '%' : '0%';
    }
  }
}
